import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'
import state from './state'
import mutations from './mutations'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)
export default new Vuex.Store({
  actions,
  getters,
  state,
  mutations,
  plugins: [createPersistedState()]
})



// WEBPACK FOOTER //
// ./src/store/index.js